import React from 'react';
import PropTypes from 'prop-types';
import FormRow from '../form/FormRow';
import FormField from '../form/FormField';
import SurveyItem from "./SurveyItem";

const SurveyComment = props => {

  let {
    title = 'inquiry_detail',
    readOnly,
    constraint,
    errorId,
    invalid,
    value,
    updateFieldValue,
  } = props;

  const _updateFieldValue = (fieldName, value, inputValue) => {
    if (updateFieldValue) {
      updateFieldValue(fieldName, value, inputValue);
    }
  };

  const onBlur = (fieldName, value, inputValue) => {
    _updateFieldValue(fieldName, value, inputValue);
  };

  const onChange = (fieldName, value, inputValue) => {
    _updateFieldValue(fieldName, value, inputValue);
  };

  return (
    <FormRow rowNameId={title} required={false}>
      <FormField
        fieldName={`field_comment`}
        controlType={'textarea'}
        constraint={constraint}
        readOnly={readOnly}
        errorId={errorId}
        errorIdValues={{
          field: title,
        }}
        invalid={invalid}
        value={value}
        onBlur={onBlur}
        onChange={onChange}  />
    </FormRow>
  )

};

SurveyComment.propTypes = {
  updateFieldValue: PropTypes.func,
};


export default SurveyComment;
